import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const rotation = keyframes`
0% {
  transform: rotate(0deg);
}
100% {
  transform: rotate(360deg);
}
`;
const Parent = styled.div<Props>`
  display: block;
  position: relative;
  width: ${(props) => props.size || 64}px;
  height: ${(props) => props.size || 64}px;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${(props) => (props.size ? props.size * 0.79 : 51)}px;
    height: ${(props) => (props.size ? props.size * 0.79 : 51)}px;
    margin: ${(props) => (props.size ? props.size * 0.1 : 6)}px;
    border: ${(props) => (props.size ? props.size * 0.1 : 6)}px solid #fff;
    border-radius: 50%;
    animation: ${rotation} 1.2s cubic-bezier(0.5, 0.1, 0.5, 0.9) infinite;
    border-color: ${(props) => props.color || '#fff'} transparent transparent transparent;
  }

  div:nth-of-type(1) {
    animation-delay: -0.45s;
  }
  div:nth-of-type(2) {
    animation-delay: -0.3s;
  }
  div:nth-of-type(3) {
    animation-delay: -0.15s;
  }
`;

type Props = {
  color?: string;
  size?: number;
  className?: string;
};

const Spinner = ({ color, size = 64, className }: Props) => (
  <Parent color={color} size={size} className={className}>
    <div />
    <div />
    <div />
    <div />
  </Parent>
);

export default Spinner;
